<template>
<div>
  <div>

  </div>
  <div>
    <div class="card mb-1">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6">
            <div class="row mb-2">
              <div class="col-sm-4">
                Form Date
              </div>
              <div class="col-sm-8">
                <DateRangePicker @updatedaterange="dateRangeChange"></DateRangePicker>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <!-- <button class="btn btn-primary float-end mb-2" @click="addNew">Add SWS</button>
            <button class="btn btn-primary float-end  mb-2" style="margin-right:10px;" @click="downloadSetting">Download</button> -->
            <button class="btn btn-primary float-end  mb-2" style="margin-right:10px;"
              @click="download">Download Excel</button>
          </div>

        </div>
      </div>
    </div>
    <div class="card mb-1">
      <div class="card-body">
         <div style="overflow-x: auto;">
        <table class="table table-sm">
          <thead class="table-light">
            <tr>
              <th>Quota Application No</th>
               <th>Form Date</th>
              <th>Applicant</th>
              <th>MNC</th>
              <th>Main Contractor</th>
              <th>Status</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idx) in param.listData" :key="idx">
              <td>{{i.quotaApplicationNo}}</td>
              <td>{{i.formDate}}</td>
              <td>{{i.nameOfCompany}}</td>
              <td>{{i.mncName}}</td>
              <td>{{i.mainContractorName}}</td>
              <td >{{i.status}}</td>
              <td >{{i.rejectReason}}</td>
            </tr>
          </tbody>
        </table>
     </div>
        
      </div>
    </div>

  </div>
</div>
</template>

<script>

import api from "@/common/api";
import apiUrl from "@/common/apiurl";
import * as TableAddons from "@/components/custom/table_addons";
import * as Forms from '@/components/custom/forms';
import * as Pickers from "@/components/custom/pickers";
export default {
  name: 'InvoiceList',
  components: {
     ...TableAddons,
    ...Forms,
    ...Pickers
  },
  data() {
    return {
      param:{
          listData:[]
      },
      statuses: [],
      pickDate:null,
      pDate:null,
      selectedCorporate:null,
      corporates:[]
    }
  },
  destroyed() {
    this.clearBreadcrumb();
  },
  mounted() {    
    this.setBreadcrumb([
      { name: 'Online Quota Report' }
    ]);
    
    this.param.startDate = null;
    this.param.endDate = null;
    this.callTable();
  },
  methods: {
    dateRangeChange(dateRange) {
      this.param.startDate = this.convertDateObjToDateStr(dateRange.start);
      this.param.endDate = this.convertDateObjToDateStr(dateRange.end);
      this.callTable();
    },
    callTable() {
      this.showLoadingScreen();
      this.param.listData = [];
      api.regularPost(apiUrl.report.quotaReport, this.param).then((response) => {
        this.hideLoadingScreen();
        if (response.status == 200) {
          console.log(response);
          this.param.listData = response.data;
        }
      });
    },
    download() {
      this.showLoadingScreen();
      
      api.downloadFile(apiUrl.report.quotaDownload,this.param,"online_quota_report.xlsx",() =>{
        this.hideLoadingScreen();
        this.showMessage("Successfully downloaded.", "success");
      });
    },
  }
}
</script>
